<div class="d-flex flex-column gap-2 h-full overflow-hidden ">
	<div>
		<div class="container d-flex flex-wrap gap-2 align-items-center compact-controls py-1 border-bottom"
			*ngIf="criteria">
			<div>
				<input type="search" class="form-control" [(ngModel)]="criteria.Keyword" (debounce)="navigateToSearch()"
					placeholder="جستجوی واژه">
			</div>
			<div>
				<app-option-selector [options]="rtwadService.statuses" [multiple]="true" [(ngModel)]="criteria.Statuses"
					(ngModelChange)="navigateToSearch()" [translation]="statusTranslation" itemClass="fs-sm"
					placeholder="وضعیت"></app-option-selector>
			</div>
			<div>
				<ng-container *ngIf="(sources$ | async) as sources">
					<select class="form-control" [(ngModel)]="criteria.Source" (change)="navigateToSearch()">
						<option [ngValue]="undefined">منبع</option>
						<option [ngValue]="'karpishe'">کارپیشه</option>
						<option [value]="source.Key" *ngFor="let source of sources">{{source.Key}} </option>

					</select>
				</ng-container>
			</div>
			<div class="mx-auto"></div>
			<div>
				<button type="button" class="btn btn-link btn-sm fs-sm"
					(click)="criteria={Source: 'karpishe',Statuses:['Pending']};navigateToSearch()">تایید</button>
			</div>
		</div>
	</div>
	<div class="d-flex flex-wrap gap-2 flex-grow-1 overflow-hidden">
		<div class="container-capped-xs mx-0 h-100 overflow-y-auto d-flex flex-column gap-2 py-2 relative">
			<ngx-spinner name="rtwad-list" type="timer"></ngx-spinner>
			<ng-container *ngIf="searchResult as search">
				<div class="kp-card m-0" *ngFor="let rtwad of search.List">
					<app-rtwad-summary [rtwad]="rtwad" mode="admin" (click)="item=rtwad;navigateToSearch()" [disableNavigate]="true"></app-rtwad-summary>
				</div>
				<app-pagination [total]="search.Total" [limit]="limit" (page)="navigateToSearch($event)"></app-pagination>
			</ng-container>
		</div>
		<div class="h-100 overflow-auto flex-grow-1 py-2">
			<div *ngIf="item" class="kp-card container-capped ">
				<div class="text-left">
					<button class="btn btn-icon btn-link" (click)="item = null;navigateToSearch()"><i
							class="fa fa-times"></i></button>
				</div>
				<app-rtwad-form [rtwadModel]="item" [isOperatorMode]="true"></app-rtwad-form>
			</div>
		</div>
	</div>
</div>
